const MainInfo = () => {
  return (
    <section className="mainInfo">
      <h2>Motorhuis laadpunt samenstellen</h2>
      <p>Gefeliciteerd!</p>
      <p>
        Je hebt een pracht oplaadpunt samengesteld! Vul jouw gegevens in en wij
        nemen graag jouw setting door. Tot snel!
      </p>
    </section>
  );
};

export default MainInfo;
